module.exports = __webpack_public_path__ + "static/media/48390309_2309077282500783_6729896389108563968_o-thumb.e825d549.jpg";